// extracted by mini-css-extract-plugin
export default {"wrapper":"TemplatesManager_wrapper__iVERr"};